import { useQuery } from "react-query";
import { ExploreCustomField } from "@/v2/entities/explore/Explore.model";
import { useCustomFieldApi } from "@/v2/entities/custom-field/CustomField.api";

export function useExploreCustomFields(): ExploreCustomField[] {
  const customFieldApi = useCustomFieldApi();

  const { data } = useQuery({
    queryKey: ["custom-fields-values"],
    queryFn: () => customFieldApi.getCustomFieldValues(),
    select: (data) =>
      data.map((customField) => ({
        id: customField.externalId,
        value: customField.key.replace(/\s+/g, "_").toLowerCase(),
        label: customField.key,
        options: customField.values.map((value) => ({
          id: value,
          name: value,
          value: value,
        })),
      })),
  });

  return data ?? [];
}
